import { Token } from "../constants";

export const getBrandColorByToken = (token: Token) => {
  const brandColorByToken: Record<Token, string> = {
    [Token.ARB]: "#12AAFF",
    [Token.GMX]: "#2D42FC",
    [Token.USDC]: "#2775CA",
    [Token.USDCE]: "#2775CA",
    [Token.WETH]: "#5D7EE7",
    [Token.WBTC]: "#F7931A",
  };
  return brandColorByToken[token];
};
